import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

interface QueryLocationVisitsPayload {
  skip?: number;
  take?: number;
  search?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  [key: string]: any;
}

interface QueryLocationVisitsResponse {
  data: any[];
  total: number;
}

const getTodayLocationVisitApi = async (): Promise<any> => {
  const response = await httpClient.get('api/location/get-today-visit', {});
  return response.data;
};

const getLastLocationVisitsApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/location/last-location-visits', {});
  return response.data.data || response.data || [];
};

const queryLocationVisitsApi = async (payload: QueryLocationVisitsPayload): Promise<QueryLocationVisitsResponse> => {
  const response = await httpClient.post<QueryLocationVisitsResponse>('api/location-visit/query', payload);
  return response.data;
};

const startLocationVisitApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/location/start-visit', payload);
  return response.data;
};

const updateUsersLocationVisitApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/location/update-users-visit', payload);
  return response.data;
};

export const useTodayLocationVisit = () => {
  return useQuery({
    queryKey: ['location-visit', 'today'],
    queryFn: getTodayLocationVisitApi,
    staleTime: 1 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useLastLocationVisits = () => {
  return useQuery({
    queryKey: ['location-visits', 'last'],
    queryFn: getLastLocationVisitsApi,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useQueryLocationVisits = () => {
  return useMutation({
    mutationFn: queryLocationVisitsApi,
  });
};

export const useStartLocationVisit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: startLocationVisitApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['location-visit', 'today'] });
      queryClient.invalidateQueries({ queryKey: ['location-visits'] });
    },
  });
};

export const useUpdateUsersLocationVisit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUsersLocationVisitApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['location-visit', 'today'] });
      queryClient.invalidateQueries({ queryKey: ['location-visits'] });
    },
  });
};
